import { useCallback } from 'react';

export default function useEmailHash() {
  const hashEmail = useCallback(async (email) => {
    if (!email) return '';

    try {
      const encoder = new TextEncoder();
      const data = encoder.encode(email.toLowerCase());
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    } catch (error) {
      console.error('useEmailHash', 'hashEmail', 'failed to hash email', error);
      return '';
    }
  }, []);

  return hashEmail;
}
